import React, { useState, useEffect ,createRef} from "react";
import {Button, Card, CardContent, Divider, Typography,Snackbar} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import '../css/weather-icons.min.css';
import '../css/weather-icons-wind.min.css';
import { useScreenshot, createFileName } from "use-react-screenshot";
import {useParams} from 'react-router-dom';
import { red } from "@material-ui/core/colors";

function WindsForRegion({forecast}){
    return (<>
    <WindsForRegionHeading/>
    {forecast
    .filter((item,index)=>{return item.wind_dir_00!==undefined})
    .map((item,index)=>{
        return (<><WindsForRegionData forecast={item} key={index}/></>)
    })}
    </>);
}
function WindsForRegionData({forecast}){
    const d=new Date(forecast.date);
    const options = { weekday: 'short', month: 'numeric', day: 'numeric' };
    const date=d.toLocaleString('el-gr', options);
    const times=['0:00-6:00','6:00-9:00','9:00-12:00','12:00-15:00','15:00-18:00','18:00-0:00'];
    const varNames=['00','06','09','12','15','18'];
    return (<>
                        <Grid container direction="row" xs={12} spacing={2} style={{backgroundColor:'inherit',flexWrap:'nowrap'}} 
                        justify='space-evenly' alignItems="center">
                            <Grid item xs={2} style={{minHeight:40}}>
                                {date}
                            </Grid>
                            {times.map((time,index)=>{
                                const wind_bf=getBeaufort(forecast['wind_kts_'+varNames[index]]);
                                return(
                                <Grid item xs={2} justify='center' container>
                                    <Card style={{marginBottom:20,paddingTop:10,backgroundColor:colorForWind(forecast['wind_kts_'+varNames[index]])}}>
                                        <Grid container direction="column" alignItems="center" style={{width:90,height:64}}>
                                            <Grid item style={{color:'white',marginBottom:4}}>
                                                {forecast['wind_kts_'+varNames[index]]}kts / {wind_bf}bf
                                        </Grid>
                                        <Grid item>
                                            <i class={'wi wi-wind wi-from-'+forecast['wind_dir_'+varNames[index]]} style={{fontSize:36,color:'white'}}></i>
                                        </Grid>
                                    </Grid>
                                    </Card>
                                </Grid>
                                )
                                }
                            )}
                        </Grid>
    </>);
}
function WindsForRegionHeading(){
    const times=['0:00-6:00','6:00-9:00','9:00-12:00','12:00-15:00','15:00-18:00','18:00-0:00'];
    return (<>
                        <Grid container direction="row" xs={12} spacing={2} 
                            style={{backgroundColor:'inherit',flexWrap:'nowrap',height:65}} justify='space-evenly' alignItems="center">
                            <Grid item xs={2}>
                            </Grid>
                            {times.map((time,index)=>{
                                return(
                                <Grid item xs={2} justify='center' container>
                                    {time}
                                </Grid>
                                )
                                }
                            )}
                        </Grid>
    </>);
}
function ForecastForRegion({forecast}){
    return (<>
                    {
                forecast.map((f,index)=>{
                    if(index>9){return '';}
                    //const dow=f.dow.substring(0,3);
                    //const date=f.date.substring(0,6);
                    const d=new Date(f.date);
                    // const fullDayOptions = { weekday: 'short', month: 'long', day: 'numeric' };
                    const shortDay1Options = { weekday: 'long' };
                    const shortDay2Options = { month: 'long', day: 'numeric' };
                    //const date=d.toLocaleString('el-gr', fullDayOptions);
                    const shortDate1=d.toLocaleString('el-gr', shortDay1Options);
                    const shortDate2=d.toLocaleString('el-gr', shortDay2Options);
                    const wind_bf=getBeaufort(f.wind_kts);
                    const iconColor='#1b4de4';
                    const iconColor2='#000000';
                    return(
                        <Grid item>
                            <Card style={{width:170}}>
                                <CardContent>
                                    <Typography variant="h7" display="inline" style={{color:iconColor2}}>{shortDate1}</Typography>
                                    <Typography variant="h7" display="block" style={{marginTop:4,color:iconColor2}}>{shortDate2}</Typography>
                                </CardContent>
                                <CardContent>
                                    <i class={getIconDay(f.cond_day)} style={{fontSize:33,color:iconColor}}></i>
                                    <Typography variant="h4" display="inline" style={{fontSize:33,color:iconColor}}>&nbsp;{f.temp_max}&deg;</Typography>
                                    <Typography variant="h7" display="inline" style={{fontSize:14,color:iconColor,fontWeight:'bold'}}>/ {f.temp_min}&deg;</Typography>
                                </CardContent>
                                <CardContent>
                                    <Grid container justify='space-between' alignItems="center" direction="row" xs={12} spacing={1}>
                                        <Grid item container justify="flex-end"  alignItems="center" xs={3} spacing={0} direction="column">
                                            <Grid item>
                                                <i class={'wi wi-night-'+f.cond_night} style={{fontSize:23,color:iconColor2}}></i>
                                            </Grid>
                                            <Grid item>
                                                &nbsp;
                                            </Grid>
                                        </Grid>
                                        <Grid item container justify="flex-end"  alignItems="center" xs={3} spacing={0} direction="column">
                                            <Grid item>
                                                <i class={'wi wi-raindrop'} style={{fontSize:23,color:iconColor2}}></i>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant="h7" display="inline">{(f.rain_perc*100).toFixed(0)}%</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid item container justify="flex-start"  alignItems="flex-end" xs={3} spacing={0} direction="column">
                                            <Grid item>
                                                <i class={'wi wi-wind wi-from-'+f.wind_dir} style={{fontSize:28,color:iconColor2}}></i>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant="h7">{wind_bf}bf</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    )
                })}
    </>)
}
function ForecastMapItem({forecast,eparchies}){
    const currentRegion=eparchies.find(x=>x.name===forecast.eparchia);
    const coords={x:currentRegion.x?currentRegion.x:0,y:currentRegion.y?currentRegion.y:0};
    return (<>
        <div draggable="true" style={{transform:'scale(0.7)',background:'rgba(255,0,0,.0)',position:'absolute',top:coords.x,left:coords.y,height:60,textAlign:'center'}}>
            <div style={{display:'flex',alignItems:'center',padding:0,marginBottom:0,fontSize:18,textShadow:'1px 1px 2px white'}}>{forecast.eparchia}&nbsp;<i class={getIconDay(forecast.cond_day)} style={{fontSize:20,textShadow:'1px 1px 1px white'}}/>
            </div>
            <div style={{display:'block',padding:0,fontSize:20,textShadow:'1px 1px 2px white'}}>
                {forecast.temp_avg}&deg;
                {forecast.humidity&&<span> {(forecast.humidity*100).toFixed(0)} <i class={'wi wi-humidity'} style={{fontSize:16,textShadow:'1px 1px 1px white'}}/></span>}
            </div>
        </div>
    </>);
}
function ForecastMap({forecast,singleregion,region,eparchies,readonly,downloadScreenshot}){
    
    return (<>
    <Grid container direction="column" alignItems="center"
        style={{maxWidth:1000,minWidth:1000,backgroundColor:'inherit'}}>
            {Object.entries(forecast)
                .filter(([key,value])=> (!singleregion || key===region))
                .map(([key,forecastForDay],index)=>{
                    const d=new Date(key);
                    const options = { weekday: 'long', month: 'long', day: 'numeric'};
                    const date=d.toLocaleString('el-gr', options);
                    return(<>
                <Grid container direction="column" alignItems="center" spacing={2} 
                                        style={{marginBottom:20,marginTop:20,backgroundColor:'inherit'}} xs={12}>
                <Grid item style={{padding:0}}>
                    <Typography variant="h5" display="inline">{date}</Typography>
                </Grid>
                <Grid item container style={{backgroundColor:'inherit'}} justify='center'>
                    <Grid item>
                        <div style={{position:'relative',width:1000,height:552,backgroundImage:'url("/admin/Map.png")',backgroundSize:'1000px 552px',backgroundRepeat:'no-repeat'}}>
                            {forecastForDay.map((forecast,index)=>{return (
                                <ForecastMapItem forecast={forecast} eparchies={eparchies}/>
                            )})}
                            
                        </div>
                    </Grid>
                </Grid>
                <Grid item  container direction="column" justify="center" alignItems="center">
                    {!readonly&&
                        <>
                        <div style={{marginBottom:10}}>
                        Download
                        </div>
                        <div>
                        <Button onClick={()=>{downloadScreenshot(key,'desktop')}} 
                            color="primary" variant="outlined">desktop
                        </Button>
                        </div>
                        </>  
                        }
                </Grid>
            </Grid>
            </>)})}
            
    </Grid>
    </>)
}

function ForecastsController({security,readonly=false,singleregion=false}){
    const {view}=useParams();
    const storedView=localStorage.getItem('view');
    const apiDomain=(process.env.NODE_ENV!=="development"?"/api":"http://"+window.location.hostname+":9000/api");
    const [isLoading,setIsLoading]=useState(true);
    const [isDataUpdating,setIsDataUpdating]=useState(false);
    const [forecast,setForecast]=useState({});
    const [mapsForecast,setMapsForecast]=useState({});
    const [eparchies,setEparchies]=useState([]);
    const [error,setError]=useState('');
    const [snackbarOpen,setSnackbarOpen]=useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarType, setSnackbarType] = useState("success");
    const [currentView,setCurrentView]=useState(view?view:(storedView?storedView:'10day'));

    useEffect(()=>{
        loadForecasts();
    },[]);

    useEffect(()=>{
        if(!readonly){
            localStorage.setItem('view',currentView);
        }
    },[currentView]);

    const loadForecasts=async ()=>{
        console.log('loading...');
        fetch(apiDomain+`/weather/forecasts/r=${Math.random()}`
        ,{"headers":{}})
            .then(res => res.text())
            .then(res => {
              const parsedResponse=JSON.parse(res);
              //alert(JSON.stringify(parsedResponse.page_context.has_more_page));
              setForecast(parsedResponse.forecasts);
              setEparchies(parsedResponse.eparchies);
              setMapsForecast(parsedResponse.mapsForecasts);
              setTimeout(()=>{
                setIsLoading(false);
              },0);
              
            })
            .catch((error)=>{
                console.log("error with API call");
                setError(error.message);
                setIsLoading(false);
            });
    }
    const updateForecastData=async()=>{
        setIsDataUpdating(true);
        fetch(apiDomain+`/weather/forecasts/readdata`
        ,{"headers":{}})
            .then(res => res.text())
            .then(res => {
              loadForecasts();
              setIsDataUpdating(false);
              setSnackbarMessage("Updated data from sheets");
              setSnackbarType("success");
              setSnackbarOpen(true);
              //alert(JSON.stringify(parsedResponse.page_context.has_more_page));
            })
            .catch((error)=>{
                console.log("error with API call");
                setError(error.message);
                setIsDataUpdating(false);
                setSnackbarMessage("Problem updating data");
                setSnackbarType("error");
                setSnackbarOpen(true);
  
            });
    }
    const download = (params, { name = "Forecast-", extension = "png" } = {}) => {
        console.log('figuring out download');
        const a = document.createElement("a");
        a.href = params.image;
        //a.href = params.image;
        a.download = createFileName(extension, params.fileName);
        a.click();
      };

    const downloadScreenshot = (key,type) => {
          const dev=process.env.NODE_ENV==="development"?'true':'false';
          const url=apiDomain+`/weather/forecasts/${currentView}/${key}/${type}/${dev}`;
          const fileName=`${currentView}forecast_${key}_${type}.png`;
        fetch(url, {
            method: 'GET',
            headers: {
              //'Content-Type': 'application/pdf',
            },
          })
          .then((response) => response.blob())
          .then((blob) => {
            // Create blob link to download
            const url = window.URL.createObjectURL(
              new Blob([blob]),
            );
            const link = document.createElement('a');
            link.href = url;
            
            link.setAttribute(
              'download',
              fileName,
            );
        
            // Append to html link element page
            document.body.appendChild(link);
        
            // Start download
            link.click();
        
            // Clean up and remove the link
            link.parentNode.removeChild(link);
          });
      };
      
    let {region}=useParams();
    const maxWidth=currentView==='winds'?760:currentView==='map'?1000:1000;
    const minWidth=currentView==='winds'?760:currentView==='map'?1000:375;
    return (<>
            <Snackbar open={snackbarOpen} autoHideDuration={2000} onClose={()=>setSnackbarOpen(false)} anchorOrigin={{vertical:'top',horizontal:'center'}}>
                <Alert  severity={snackbarType}>{snackbarMessage}</Alert>
            </Snackbar>
            {!isLoading&&(!readonly && !security.forecasts)&&<>No access</>}
            {isLoading&&
                <>
                Loading
                </>
            }
            {!isLoading && (readonly || security.forecasts)&&
                error===''&&
                <>
                    {!readonly&&<>
                    <Grid container item spacing={2} direction="column" alignItems="center" style={{padding:0,maxWidth:maxWidth,minWidth:minWidth}}>
                        <Grid item>
                            <Button onClick={()=>{updateForecastData()}} 
                                    disabled={isDataUpdating}
                                    color="secondary" variant="outlined">
                                update data from sheets
                            </Button>
                        </Grid>
                        <Grid item>
                        <Tabs
                            value={currentView}
                            onChange={(event, newValue)=>{setCurrentView(newValue)}}
                            textColor="primary"
                            indicatorColor="primary"
                        >
                            <Tab value="10day" label="10ημερες" />
                            <Tab value="winds" label="Ανεμοι" />
                            <Tab value="map" label="Χαρτες" />
                        </Tabs>
                        </Grid>
                    </Grid>
                    </>}
                {currentView!=='map'&&
                    Object.entries(forecast)
                    .filter(([key,value])=> (!singleregion || key===region))
                    .map(([key,value],index) => {
                        const regionName=eparchies.find(eparchia => eparchia.key === key).name;
                            return(
                                <>
                                <Grid container direction="column" alignItems="center" key={key} 
                                    style={{maxWidth:maxWidth,minWidth:minWidth,backgroundColor:'inherit'}}>
                                    <Grid container direction="column" alignItems="center" spacing={2} 
                                        style={{marginBottom:20,marginTop:20,backgroundColor:'inherit'}} xs={12}>
                                        <Grid item style={{padding:0}}>
                                            <Typography variant="h5" display="inline">{regionName}</Typography>
                                        </Grid>
                                        <Grid item style={{padding:0}}>
                                        {currentView==='10day'&&<Typography variant="h7" display="inline">10-ήμερη πρόβλεψη</Typography>}
                                        {currentView==='winds'&&<Typography variant="h7" display="inline">Πρόβλεψη Ανέμων</Typography>}
                                        </Grid>
                                        {currentView==='10day'&&
                                            <Grid item >
                                            <Grid container spacing={1} direction="row" justify="center">
                                                <ForecastForRegion forecast={forecast[key]} key={key}></ForecastForRegion>
                                            </Grid>
                                            </Grid>
                                        }
                                        {currentView==='winds'&&
                                            <Grid item container style={{backgroundColor:'inherit'}} xs={12}>
                                            <WindsForRegion forecast={forecast[key]} key={key}></WindsForRegion>
                                            </Grid>
                                        }
                                        <Grid item  container direction="column" justify="center" alignItems="center">
                                            {!readonly&&
                                                <>
                                                <div style={{marginBottom:10}}>
                                                Download {regionName}
                                                </div>
                                                <div>
                                                <Button onClick={()=>{downloadScreenshot(key,'desktop')}} 
                                                    color="primary" variant="outlined">desktop
                                                </Button>
                                                &nbsp;
                                                {currentView==='10day'&&<Button onClick={()=>{downloadScreenshot(key,'mobile')}} 
                                                    color="primary" variant="outlined">mobile
                                                </Button>
                                                }
                                                </div>
                                                </>  
                                                }
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {!singleregion&&<Divider style={{maxWidth:1000}}/>}
                                </>
                            )
                    })
                }
                {currentView==='map'&&
                    <ForecastMap 
                        forecast={mapsForecast} 
                        singleregion={singleregion}
                        region={region}
                        eparchies={eparchies} 
                        readonly={readonly} 
                        downloadScreenshot={downloadScreenshot}
                    />
                }
                </>
            }
            {!error===''&&<>Error: {error}</>}
    
    </>)
}
function colorForWind(knots){
    let color='rgba(0,0,0,1)';
    switch (true){
        case knots<=3:
            color='rgba(100,0,255,1)';
            break;
        case knots<=5:
            color='rgba(50,0,255,1)';
            break;
        case knots<=7:
            color='rgba(0,50,255,1)';
            break;
        case knots<=8:
            color='rgba(9,100,255,1)';
            break;
        case knots<=10:
            color='rgba(39,150,255,1)';
            break;
        case knots<=12:
            color='rgba(61,199,255,1)';
            break;
        case knots<=14:
            color='rgba(75,230,240,1)';
            break;
        case knots<=15:
            color='rgba(75,230,240,1)';
            break;
        case knots<=16:
            color='rgba(63,193,146,1)';
            break;
        case knots<=18:
            color='rgba(73,212,15,1)';
            break;
        case knots<=20:
            color='rgba(80,230,0,1)';
            break;
        case knots<=25:
            color='rgba(184,255,97,1)';
            break;
        case knots<=27:
            color='rgba(255,254,2,1)';
            break;
        case knots<=28:
            color='rgba(253,255,1,1)';
            break;
        case knots<=32:
            color='rgba(251,200,0,1)';
            break;
        case knots<=35:
            color='rgba(255,175,0,1)';
            break;
        case knots<=37:
            color='rgba(230,125,0,1)';
            break;
        case knots<=40:
            color='rgba(223,89,6,1)';
            break;
        case knots<=100:
            color='rgba(246,70,8,1)';
            break;
        default:
            color='rgba(0,0,0,1)';
    }
    return color;
}
function getBeaufort(knots) {
    let beaufort=0;
    switch (true) {
      case knots < 1:
        beaufort = 0;
        break;
      case knots < 4:
        beaufort = 1;
        break;
      case knots < 7:
        beaufort = 2;
        break;
      case knots < 11:
        beaufort = 3;
        break;
      case knots < 17:
        beaufort = 4;
        break;
      case knots < 22:
        beaufort = 5;
        break;
      case knots < 28:
        beaufort = 6;
        break;
      case knots < 34:
        beaufort = 7;
        break;
      case knots < 41:
        beaufort = 8;
        break;
      case knots < 48:
        beaufort = 9;
        break;
      case knots < 56:
        beaufort = 10;
        break;
      case knots < 64:
        beaufort = 11;
        break;
      case knots > 63:
        beaufort = 12;
        break;
    default:
        beaufort=12;
    }
    return beaufort;
}
function getIconDay(forecastCond){
    if(forecastCond==='hot') return 'wi wi-hot';
    return 'wi wi-day-'+forecastCond;
}
export {ForecastsController};